<template>
  <div
    class="bookmark-button"
    data-cy="bookmark-button"
  >
    <img
      @click="onClick"
      v-if="post.bookmarked"
      src="@/assets/BookmarkedIconFilled.svg"
      class="bookmark-icon"
    />
    <img
      @click="onClick"
      v-else
      src="@/assets/BookmarkedIcon.svg"
      class="bookmark-icon"
    />
    <div class="bookmark-text" @click="onClick">
      &nbsp;{{ $t('post.bookmarkPost.bookmark') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'BookmarkPost',
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick () {
      return this.post.bookmarked ? this.unbookmark() : this.bookmark()
    },
    bookmark () {
      this.$store.dispatch('bookmarkPost', this.post.id)
    },
    unbookmark () {
      this.$store.dispatch('unbookmarkPost', this.post.id)
    }
  }
}
</script>

<style scoped lang="scss">
.bookmark-button {
    margin-left: 1rem;
    display: flex;
    cursor: pointer;
}

.bookmark-text {
  cursor: pointer;
}
</style>
